














import { Component, Prop, Vue } from "vue-property-decorator";
import { ColorConstruct } from '@/utilityModels/colorConstruct'
import { Sketch } from 'vue-color';

@Component({
  components: {
        'sketch-picker': Sketch
    }
})
export default class ColorPicker extends Vue
{
    // タグ
    @Prop() tag! : string;
    // 色
    @Prop() color! : ColorConstruct;

    // カラーパレットの設定
    private get presetColors(): string[] {
        return [
            '#D0021B', '#F5A623', '#F8E71C', '#8B572A', '#7ED321', '#417505', '#BD10E0', '#9013FE',
            '#4A90E2', '#50E3C2', '#B8E986', '#000000', '#4A4A4A', '#9B9B9B', '#C8C8C8', '#FFFFFF',
        ];
    }

    mounted()
    {
        this.changeInputMode(1);
    }

    destroyed()
    {
        this.changeInputMode(0);
    }

    private changeInputMode(mode)
    {
        this.$store.dispatch("changeInputMode", mode);
    }

    private get colors() {
        return this.color.hex;
    }

    private updateValue(newValue) {
        this.$emit('changingColor', ColorConstruct.fromHexString(newValue.hex), this.tag);
    }

    private close() {
        this.$emit('changedColor', this.color, this.tag);
        this.changeInputMode(0);
        this.$emit('close');
    }
}
